var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"btn",class:( _obj = {}, _obj[("btn-" + _vm.flavor)] = true, _obj[("btn-" + _vm.color)] = true, _obj[("btn-" + _vm.size)] = true, _obj['btn-block'] =  _vm.block, _obj.active = _vm.active, _obj ),attrs:{"type":_vm.type,"role":"button","disabled":_vm.disabled,"aria-label":_vm.label||false},on:{"click":_vm.clicked}},_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }